export default {
    intro: `Seed Letters are the smallest elements that make up words.<br />
            Let's explore the relationships between words made from Seed Letters and characters. `,
    options: {
        textbook: 'Words from textbook',
        page: 'Textbook',
    },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `${round === 1 ? 'First' : 'Second'} Letter`;
        },
        title: {
            word: 'Letter',
            example1: 'Example Word 1',
            example2: 'Example Word 2',
            check: 'Review Learned Words',
            question: 'Word Question',
            meaning: 'Check Semantic Relationship',
            meaningQuestion: 'Semantic Relationship Question',
        },
    },
    indicator: {
        word: 'Learn the shape, sound, and meaning of the Seed Letter.',
        example1: 'Learn how the Seed Letter is used in words.',
        example2: 'Learn how the Seed Letter is used in words.',
        check: 'Learn two words that contain the Seed Letter.',
        question: 'Which of the two words uses the "{ reading }({ cn })" letter?',
        meaning: 'Learn how the Seed Letter is used in words.',
        meaningQuestion: 'What is the relationship between { first } and { second }?',
        // Relation explanation (lead sentence) by type (0 synonym / 1 antonym / 2 hierarchy / 3 homograph / 4 polysemy)
        desciption: {
            0: '<strong>{ first }</strong> and <strong>{ second }</strong> have similar meanings.',
            1: '<strong>{ first }</strong> and <strong>{ second }</strong> have opposite meanings.',
            2: '<strong>{ first }</strong> includes the meaning of <strong>{ second }</strong>.',
            3: '<strong>{ first }</strong> and <strong>{ second }</strong> are both read as { sound }, but have different meanings.',
            4: '<strong>{ first }</strong> can mean <strong>{ meaning1 }</strong>, and it can also mean <strong>{ meaning2 }</strong>.',
        },
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? 'This is a section where Students spin the cubes to learn on their own.'
                : 'Try spinning the cubes yourself to learn the letters.';
        },
        wrongAnswer: {
            lead: 'Shall we think again?',
            body: 'Look at the meaning and choose the right word.',
        },
    },

    description: ({ values }: { values: { type: number } }) => {
        const { type } = values;
        if (type === 0) {
            return 'Synonym';
        }
        if (type === 1) {
            return 'Antonym';
        }
        if (type === 2) {
            return 'Hierarchy';
        }
        if (type === 3) {
            return 'Homograph';
        }
        if (type === 4) {
            return 'Polysemy';
        }
        if (type === 5) {
            return 'None';
        }
        return 'None';
    },
    relationResult: {
        lead: 'This kind of relationship is called',
        tail: () => '.',
    },
    result: {
        correct: 'Correct',
        incorrect: 'Incorrect',
        selected: 'Selected',
    },
    buttons: {
        next: 'Next',
        learn: 'Learn Words',
        nextLearn: 'Next Word',
        collectWord: 'Review Words',
        check: 'Review Learned Words',
        seoncdLearn: 'Learn Second Letter',
        relation: 'Learn Semantic Relationship',
        prev: 'Back',
        finishStudy: 'Finish Learning',
        desciption: 'View Explanation',
    },
    guide: {
        cube: 'Click the cube to spin it.',
    },
    study: {
        example: 'Example Sentence',
        meaning: 'Meaning',
    },
};
